import { createApp } from 'vue'
import vuetify from './plugins/vuetify'
import 'vuetify/styles'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'
import { JazelAppConfig } from '@jazel/jazel-vuetify'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import App from './App.vue'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPersist)
app.use(pinia)
app.use(vuetify)
app.use(Toast, {
  position: 'top-right',
  timeout: 5000,
})
app.use(JazelAppConfig, {
  productId: 'coupon_builder',
  isEmbedded:
    document.getElementById('coupon-builder-admin')?.parentNode !==
    document.body,
  cdnUrl: import.meta.env.VITE_CDN_URL,
  jamsFrontendUrl: import.meta.env.VITE_JAMS_FRONTEND_URL,
  jamsBackendUrl: import.meta.env.VITE_JAMS_BACKEND_URL,
})

app.mount('#coupon-builder-admin')
